import React from "react";

const FALLBACK_CAPTIONS_SRC =
  "data:text/vtt;charset=utf-8,WEBVTT%0A%0A00%3A00%3A00.000%20--%3E%2099%3A59%3A59.000%0ACaptions%20are%20not%20available%20for%20this%20video.%0A";

const captionSrcForAsset = (asset = {}) =>
  asset.captionsUrl ||
  asset.captionUrl ||
  asset.subtitlesUrl ||
  asset.subtitleUrl ||
  asset.transcriptUrl ||
  FALLBACK_CAPTIONS_SRC;

const VideoCaptionTrack = ({ asset, label = "English captions" }) => (
  <track
    kind="captions"
    src={captionSrcForAsset(asset)}
    srcLang="en"
    label={label}
  />
);

export default VideoCaptionTrack;
